/* Category prices use the selected variant in GemPages' existing product context. */
(() => {
  const root = document.getElementById('MainContent');
  const config = document.getElementById('yna-category-price-config');
  if (!root || !config) return;
  const money = new Intl.NumberFormat(config.dataset.locale || 'en-US', {
    style: 'currency', currency: config.dataset.currency || 'USD'
  });
  function refresh() {
    root.querySelectorAll('gp-product[gp-context]').forEach(card => {
      let context;
      try { context = JSON.parse(card.getAttribute('gp-context')); } catch { return; }
      const variant = context.variantSelected;
      const title = card.querySelector('gp-product-title');
      if (!title || !variant || !Number.isFinite(variant.price) || variant.price < 0 || card.querySelector('gp-product-price')) return;
      let price = card.querySelector('.yna-category-price');
      if (!price) {
        price = document.createElement('div');
        price.className = 'yna-category-price';
        const amount = document.createElement('span');
        amount.className = 'yna-category-price__amount';
        const option = document.createElement('span');
        option.className = 'yna-category-price__option';
        price.append(amount, option);
        title.insertAdjacentElement('afterend', price);
      }
      const amount = price.querySelector('.yna-category-price__amount');
      const option = price.querySelector('.yna-category-price__option');
      const formatted = money.format(variant.price / 100);
      const label = context.hasOnlyDefaultVariant ? '' : (variant.public_title || variant.title || '');
      if (amount.textContent !== formatted) amount.textContent = formatted;
      if (option.textContent !== label) option.textContent = label;
    });
  }
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  });
  refresh();
  observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['gp-context'] });
})();
